import styled from "styled-components";
import React, { useEffect,useState } from "react";
import { Route, Link } from "react-router-dom";
import Button from "../../../Elements/Button";
import { db, auth } from "../../../../config/firebase";
import moment from 'moment';

const ActionButton = styled.button`
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: normal;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;

    color: #333;
    background-color: #fff;
    border-color: #ccc;

    padding: 5px 10px;
    font-size: 12px;
    line-height: 1.5;
    border-radius: 3px;

    border-radius: 8px;

    border-width: 1px;
    padding: 5px 12px;
    border-color: #babacc;

    padding-top: 4px;
    padding-bottom: 4px;

    &:not(:first-child) {
        margin-left: 4px;
    }

    &:hover {
        color: #333;
        background-color: #ebebeb;
    }
`

const RecordingsList = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;

    margin-top: 34px;

    .FirstCol {
        padding-left: 32px;
    }
    
    .RecordingHeader {

        font-weight: 600;
        font-size: 12px;
        min-height: 34px;
        line-height: 34px;
        
        line-height: 34px;
        border-bottom: 2px solid #eee;
    }
    .RecordingCell {
        line-height: 24px;
        padding-top: 6px;
        padding-bottom: 6px;
    }
`

const Recording_ = ({className, topic, recordingDate,recordingId, deleteRecording, id}) => {
    const momentDate = moment(recordingDate.toDate());
    const recordingDateFormatted = momentDate.format('ddd, MMM Do');
    const recordingDateTimeFormatted = momentDate.format('h:mm:ss A');
    const recordingIdFormatted =  recordingId.toString().substring(0, 3) + ' ' + recordingId.toString().substring(3, 7) + ' ' + recordingId.toString().substring(7, 11);
    return (
        <>
            <div className="RecordingCell FirstCol">{recordingDateFormatted}<br/>{recordingDateTimeFormatted}</div>
            <div className="RecordingCell">{topic}</div>
            {/* <div className="RecordingCell">{id}</div> */}
            <div className="RecordingCell">{recordingIdFormatted}</div>
            <div className="RecordingCell">
                <ActionButton id="start-recording">Start</ActionButton>
                <ActionButton id="delete-recording" onClick={e=>deleteRecording(id)}>Delete</ActionButton>
            </div>
        </>
    )
}
const Recording = styled(Recording_)`
`

const LocalRecordings_ = ({className}) => {
    const [recordings, setRecordings] = useState();
    useEffect(()=>{
        db.collection('recordings').where('uid','==',auth.currentUser.uid).where('recordingDate','>',new Date()).get()
            .then(snap => {
                // console.log(snap.size);
                let recordings = [];
                snap.forEach(doc => {
                    recordings.push({...doc.data(), id: doc.id});
                });
                setRecordings(recordings);
            })
    }, []);

    const deleteRecording = id => {
        db.collection('recordings').doc(id).delete()
            .then(snap => {
                console.log('deleted document', id);
                setRecordings(recordings =>  recordings.filter(m=>m.id!==id))
            })
            .catch(err => {
                console.log('could not delete doc', id, err);
            })
    }
    
    return (
        <div className={className}>

            {/* <Button id='schedule-new-recording' to="/recording/schedule" style={{width: "auto"}}>Schedule a New Recording</Button> */}
            
            <RecordingsList>

                <div className="RecordingHeader FirstCol">Topic</div>
                <div className="RecordingHeader">Recording ID</div>
                <div className="RecordingHeader">Start Time</div>
                <div className="RecordingHeader">File Size</div>
                <div className="RecordingHeader"></div>

                {recordings && recordings.map(recording => {
                    return (
                        <Recording key={recording.id} {...recording} deleteRecording={deleteRecording} id={recording.id}/>
                    )
                })}
            </RecordingsList>
            
        </div>
    )
}

const LocalRecordings = styled(LocalRecordings_)`

    
`

export default LocalRecordings